import React from 'react';
import {
  ClassNamesState,
  CommonPropsAndClassName,
  DropdownIndicatorProps,
  GroupBase,
} from 'react-select';
/* eslint-disable import-x/no-unresolved */
import { StylesProps } from 'react-select/dist/declarations/src/styles';
import ArrowDown from '../icons/sharp/regular/AngleDown';

export const getStyleProps = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
  Key extends keyof StylesProps<Option, IsMulti, Group>,
>(
    props: Pick<
    CommonPropsAndClassName<Option, IsMulti, Group>,
    'cx' | 'getStyles' | 'getClassNames' | 'className'
    > &
    StylesProps<Option, IsMulti, Group>[Key],
    name: Key,
    classNamesState?: ClassNamesState,
  ) => {
  const {
    cx, getClassNames, className,
  } = props;
  return {
    className: cx(classNamesState ?? {}, getClassNames(name, props), className),
  };
};

export default function DropdownIndicator(props: DropdownIndicatorProps) {
  const { innerProps } = props;
  return (
    <div
      {...getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true,
      })}
      {...innerProps}
    >
      <ArrowDown />
    </div>
  );
}
